import { Expose } from 'class-transformer';
import { DateTime } from 'luxon';
import TransformIsoStringToDateTime from '../custom-transformers/TransformIsoStringToDateTime';

export class DefaultUUIDViewDto {
  @Expose() id: string;

  @Expose()
  @TransformIsoStringToDateTime({ toClassOnly: true })
  createdAt: DateTime;

  @Expose()
  @TransformIsoStringToDateTime({ toClassOnly: true })
  updatedAt: DateTime;
}
